import styles from './style.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class TextSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get variant(): string {
        return this.dataset.variant ?? 'vertical';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`base-grid`, `variant-${this.variant}`);
        container.innerHTML = `
            <div class="overline"></div>
            <div class="title"></div>
            <div class="content">
                <div class="subtitle"></div>
                <div class="text-content"></div>
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(container.querySelector('.subtitle'), 'subtitle');
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.text-content'));
        // Remove CTA if not set
        if(!this.querySelector('[slot=cta]')) {
            container.querySelector('.cta').remove();
        }
        return container;
    }

}

customElements.define('nxt-text-section', TextSection);
